<template>
    <b-overlay :show="loadProcessing>0" z-index="2147483647" style="height: 100%"
               opacity="0.02" variant="white"
    >
        <div class="tools-container no-print">
            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>
            <b-button variant="primary" @click="btnPrintClicked">Печать</b-button>
            <b-button variant="secondary" @click="btnCloseClicked" class="ml-2">Закрыть</b-button>
        </div>

        <div class="parent-container">
            <div>{{company}}</div>

            <div class="mt-3 w-100">
                <div class="d-flex flex-row justify-content-between w-100">
                    <div class="w-300px mt-2">
                        <h3 class="font-weight-bolder mb-0">Паспорт №: {{recordIdentity}}<br/></h3>
                        <span>Дата поверки: {{dtShort}}</span><br/>
                        Поверка <span class="font-italic">{{rpPhase}}</span> электронного счетчика
                    </div>
                    <div class="w-400px">
                        <div class="p-1 ml-22 font-size-sm overflow-auto" style="border: #000 1px dotted">
                            <img :src="getImgLink()" width="70" height="70" class="float-left d-block"/>
                            <span class="d-block mt-5 ml-24">Для проверки паспорта перейдите на сайт
                                kyzmat.oshelectro.kg или отсканируйте QR-код</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-5">
                <span class="font-weight-bolder">Модель счетчика / U ном. / I ном.:</span> {{dataRow1}}
                <br/>
                <span class="font-weight-bolder">Заводской № / Показание / Год выпуска:</span> {{dataRow2}}
                <br/>
                <span class="font-weight-bolder">Одноразовая плобма / Гос.стандарт / Срок поверки до:</span> {{dataRow3}}
            </div>
            <div class="mt-5 w-100">
                <div style="width: 200px; float:left">
                    Гос. поверитель:
                </div>
                <span style="margin-left: 150px">____________________
                    <span class="ml-2">{{statementChecker}}</span>
                </span>
            </div>
            <div class="mt-5 w-100">
                <div style="width: 200px; float:left">
                    Специалист ЦРПУ:
                </div>
                <span style="margin-left: 150px">____________________
                    <span class="ml-2">{{createdByUser}}</span>
                </span>
            </div>
            <div class="mt-3">
                <div style="width: 200px; float:left">
                    Начальник ЦРПУ:
                </div>
                <span style="margin-left: 150px">____________________
                    <span class="ml-2">{{srpuHead}}</span>
                </span>
            </div>
        </div>

    </b-overlay>
</template>

<script>
    import axios from "axios";

    export default {
        name: "BlankRPDeviceRegisterJournalPassport",
        data() {
            return {
                userData: this.$store.getters.getUserData,
                loadProcessing: 0,

                err: false,
                errText: "",
                errVariant: "danger",

                sessionUid: "",
                recordUid: "",

                recordIdentity: 0,
                dtShort: "",
                dataRow1: "",
                dataRow2: "",
                dataRow3: "",
                createdByUser: "",
                company: "",
                companyWebSite: "",
                validBefore: "",
                rpPhase: "",
                srpuHead: "",
                statementChecker: "",
            }
        },
        created() {
            document.title = "ЭЦОН - Печать паспорта"

            this.sessionUid = this.$route.query.sessionUid || ""
            this.recordUid = this.$route.query.recordUid || ""
        },
        mounted() {
            this.loadData()
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            loadData() {
                this.loadProcessing++
                axios.post("/ws/ws.svc/GetDocsBlankInfo", {
                        'Session_UID': this.sessionUid,
                        'F_DocBlank_UID': 3,
                        'F_Language_UID': 0,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(result)) {
                                        this.recordIdentity = result.RecordIdentity || 0
                                        this.dtShort = result.DTShort.toString() || ""
                                        this.dataRow1 = result.DataRow1.toString() || ""
                                        this.dataRow2 = result.DataRow2.toString() || ""
                                        this.dataRow3 = result.DataRow3.toString() || ""
                                        this.createdByUser = result.CreatedByUser.toString() || ""
                                        this.company = result.Company.toString() || ""
                                        this.companyWebSite = result.CompanyWebSite.toString() || ""
                                        this.validBefore = result.ValidBefore.toString() || ""
                                        this.rpPhase = result.RPPhase.toString() || ""
                                        this.srpuHead = result.SRPUHead.toString() || ""
                                        this.statementChecker = result.StatementChecker.toString() || ""
                                    } else {
                                        this.errTextShow(resp.data.response.toString(), "danger", true)
                                    }
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            btnPrintClicked() {
                window.print()
            },
            btnCloseClicked() {
                window.close()
            },
            getImgLink() {
                return `ws/blankqrcode?session_uid=${this.sessionUid}&docblank_uid=3&uid=${this.recordUid}&l=0`
            }
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>
    .tools-container {
        margin: 20px auto 0 auto;
        width: 900px;
    }

    .parent-container {
        background-color: #fff;
        margin: 20px auto;
        padding: 40px 40px 40px 80px;
        width: 900px;
        min-height: 500px;
        /*height: 1273px;*/
        font-family: "Calibri", "Helvetica", "sans-serif";
        font-size: 11pt !important;
    }

    .clear-fix {
        clear: both;
    }

    @media print {
        @page {
            size: A4;
            margin: 0;
            font-family: "Calibri", "Helvetica", "sans-serif";
            color: #000 !important;
        }

        .parent-container {
            width: 100%;
        }

        .no-print {
            display: none;
        }
    }
</style>